$(document).ready(function ($) {
  $(".smooth-scroll").click(function (e) {
    e.preventDefault();
    var where_to = $(this).attr("href");

    if (where_to == "#question-section") {
      $(".stamped-summary-actions-newquestion").focus();
    }

    if (where_to == "#q-and-a-section") {
      $("#tab-questions").click();
      $(".stamped-summary-actions-newquestion").focus();
    }

    if (where_to == "#review-section") {
      $(".stamped-summary-actions-newreview").focus();
    }

    $("html, body").animate(
      {
        scrollTop:
          $('[name="' + $.attr(this, "href").substr(1) + '"]').offset().top -
          200,
      },
      500
    );
    return false;
  });

  $(".increment").click(function (e) {
    e.preventDefault();
    var current_element = $(this)
      .closest("div.cart-qty")
      .find("input[name='quantity']");
    var current_val = $(this)
      .closest("div.cart-qty")
      .find("input[name='quantity']")
      .val();
    if (parseFloat(current_val) >= 1) {
      var new_val = parseFloat(current_val) + 1;
      current_element.val(new_val);
    }
    var desired_qty = $("#quantity").val();
    $("#quantity").attr("aria-label", "Purchase quantity of " + desired_qty);
  });

  $(".decrement").click(function (e) {
    e.preventDefault();
    var current_element = $(this)
      .closest("div.cart-qty")
      .find("input[name='quantity']");
    var current_val = $(this)
      .closest("div.cart-qty")
      .find("input[name='quantity']")
      .val();

    if (parseFloat(current_val) >= 2) {
      var new_val = parseFloat(current_val) - 1;
      current_element.val(new_val);
    }
    var desired_qty = $("#quantity").val();
    $("#quantity").attr("aria-label", "Purchase quantity of " + desired_qty);
  });
});
